import { create } from 'zustand'
import { tokenStore } from './tokenStore'

const PROFILE_KEYS = [
  'user',
  'userFirstName',
  'userLastName',
  'companyName',
  'companyID'
]

function persistProfile (state) {
  PROFILE_KEYS.forEach(key => {
    const value = state[key]
    if (value === null || value === undefined) {
      sessionStorage.removeItem(key)
    } else {
      sessionStorage.setItem(key, String(value))
    }
  })
}

function clearProfile () {
  PROFILE_KEYS.forEach(key => sessionStorage.removeItem(key))
}

function hydrateProfile () {
  const state = {}
  PROFILE_KEYS.forEach(key => {
    const raw = sessionStorage.getItem(key)
    if (raw !== null) {
      state[key] = raw
    }
  })
  return state
}

export const useAuthStore = create(set => {
  const updateAndPersist = payload => {
    set(currentState => {
      const nextState = { ...currentState, ...payload }

      persistProfile(nextState)

      return payload
    })
  }

  return {
    user: null,
    userFirstName: null,
    userLastName: null,
    companyName: null,
    isAuthenticated: false,
    companyID: null,

    ...hydrateProfile(),

    setAuth: payload => {
      updateAndPersist(payload)
    },

    updateCompany: companyID => {
      updateAndPersist({ companyID })
    },

    logout: () => {
      tokenStore.clearTokens()
      set({
        user: null,
        userFirstName: null,
        userLastName: null,
        companyName: null,
        isAuthenticated: false,
        companyID: null
      })
      clearProfile()
    }
  }
})
